import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Search } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/Dialog';
import { Input } from '../ui/Input';
import { usePlatform } from '../../contexts/PlatformContext';
import { entityName } from '../../data/entities';
import { STAGE_META, trackLabel } from '../../utils/stages';
interface CommandSearchProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}
export function CommandSearch({
  open,
  onOpenChange
}: CommandSearchProps) {
  const {
    applications
  } = usePlatform();
  const navigate = useNavigate();
  const [query, setQuery] = React.useState('');
  const results = React.useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return applications.slice(0, 6);
    return applications.filter(record => record.eventName.toLowerCase().includes(q) || record.ref.toLowerCase().includes(q) || entityName(record.entityId).toLowerCase().includes(q) || record.emirate.toLowerCase().includes(q)).slice(0, 8);
  }, [applications, query]);
  function openRecord(id: string) {
    onOpenChange(false);
    setQuery('');
    navigate(`/applications/${id}`);
  }
  return <Dialog open={open} onOpenChange={onOpenChange} data-id="element-695" data-mp="3gzyzv95yk72p">
      <DialogContent className="max-w-xl p-0" data-id="element-696" data-mp="3lw5xmeo7ac9k">
        <DialogHeader className="border-b border-border px-4 py-3" data-id="element-697" data-mp="3lz1us0s84wwy">
          <DialogTitle className="text-sm" data-id="element-698" data-mp="digqgxajes06">Search records</DialogTitle>
        </DialogHeader>
        <div className="px-4 py-3" data-id="element-699" data-mp="iexfdtpk9aeb">
          <div className="relative" data-id="element-700" data-mp="iibl9bxfo1qi">
            <Search className="pointer-events-none absolute left-2.5 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-muted-foreground" aria-hidden="true" data-id="element-701" data-mp="3rvt1d6lntiu" />
            <Input autoFocus value={query} onChange={event => setQuery(event.target.value)} placeholder="Reference, event, entity or emirate" className="pl-8" aria-label="Search records" data-id="element-702" data-mp="wg9rtv5iitvg" />
          </div>
          <ul className="mt-3 max-h-72 overflow-y-auto" data-id="element-703" data-mp="16342s03gotjy">
            {results.length === 0 && <li className="px-1 py-6 text-center text-xs text-muted-foreground" data-id="element-704" data-mp="121it0nm84vdz">
                No records match “{query}”.
              </li>}
            {results.map(record => <li key={record.id} data-id="element-705" data-mp="s4e5ajcqcrv2">
                <button type="button" onClick={() => openRecord(record.id)} className="flex w-full items-center justify-between gap-3 rounded-sm px-2 py-2 text-left hover:bg-muted" data-id="element-706" data-mp="s5fgqoxnrgdb">
                  <span className="min-w-0" data-id="element-707" data-mp="ecpv4lm1kdgq">
                    <span className="block truncate text-[13px] font-medium" data-id="element-708" data-mp="ee0wkes0l94o">
                      {record.eventName}
                    </span>
                    <span className="block truncate text-[11px] text-muted-foreground" data-id="element-709" data-mp="4ea56lyr3a8t">
                      {entityName(record.entityId)}
                    </span>
                  </span>
                  <span className="shrink-0 text-right" data-id="element-710" data-mp="2l0q5m4388lwc">
                    <span className="block font-mono text-[11px] text-muted-foreground" data-id="element-711" data-mp="2kz5b2egwx2yh">
                      {record.ref}
                    </span>
                    <span className="block text-[11px] text-muted-foreground" data-id="element-712" data-mp="2u14u1cbhmh42">
                      {trackLabel(record.track)} · {STAGE_META[record.stage].label}
                    </span>
                  </span>
                </button>
              </li>)}
          </ul>
        </div>
      </DialogContent>
    </Dialog>;
}